
export const devinfors = [
  {
    name:['聚合釜卸料泵_PVCYZ277','聚合釜卸料泵_PVCYZ278','聚合釜卸料泵_PVCYZ279'],
    nameshow:'聚合釜卸料泵_PVCYZ277',
    leftX:"70%",
    topY:'30%',
    status:null,
    current:null,
    temperature:null,
    val:[]
},
{
    name:['VCM加料泵_PVCYZ306','VCM加料泵_PVCYZ307'],
    nameshow:'VCM加料泵_PVCYZ306',
    leftX:"75%",
    topY:'25%',
    status:null,
    current:null,
    temperature:null,
    val:[]
},
{
      name:['1#炉净气风机_DSYZ001'],
      nameshow:'1#炉净气风机_DSYZ001',
      leftX:"13%",
      topY:'45%',
      status:null,
      current:null,
      temperature:null,
      val:[]
},
{
      name:['8#炉净气风机_DSYZ206'],
      nameshow:'8#炉净气风机_DSYZ206',
      leftX:"43%",
      topY:'46%',
      status:null,
      current:null,
      temperature:null,
      val:[]
},
{
  name:['给水泵2_HCYZ002','给水泵1_HCYZ001'],
  nameshow:'给水泵2_HCYZ002',
        leftX:"58%",
        topY:'38%',
        status:null,
        current:null,
        temperature:null,
        val:[]
},

{
  name:['球罐单体泵A_HCYZ080','球罐单体泵B_HCYZ081'],
  nameshow:'球罐单体泵A_HCYZ080',
  leftX:"70%",
  topY:'40%',
  status:null,
  current:null,
  temperature:null,
  val:[]
},{
  name:['阳极液循环泵_SJYZ019','阳极液循环泵_SJYZ020'],
  nameshow:'阳极液循环泵_SJYZ019',
  leftX:"73%",
  topY:'48%',
  status:null,
  current:null,
  temperature:null,
  val:[]
},{
  name:['氢压机_SJYZ055'],
  nameshow:'氢压机_SJYZ055',
  leftX:"68%",
  topY:'47%',
  status:null,
  current:null,
  temperature:null,
  val:[]
},{
  name:['氢压机_SJYZ085'],
  nameshow:'氢压机_SJYZ085',
  leftX:"47%",
  topY:'46%',
  status:null,
  current:null,
  temperature:null,
  val:[]
},{
  name:['烧碱泵_SJYZ122','烧碱泵_SJYZ123'],
  nameshow:'烧碱泵_SJYZ122',
  leftX:"51%",
  topY:'44%',
  status:null,
  current:null,
  temperature:null,
  val:[]
},{
  name:['氢压机_GJYZ200','氢压机_GJYZ201','氢压机_GJYZ202'],
  nameshow:'氢压机_GJYZ200',
  leftX:"51%",
  topY:'28%',
  status:null,
  current:null,
  temperature:null,
  val:[]
},
{
  name:['压缩机_YQYZ001','压缩机_YQYZ002','压缩机_YQYZ003','压缩机_YQYZ004','压缩机_YQYZ005'],
  nameshow:'压缩机_YQYZ001',
        leftX:"30%",
        topY:'32%',
        status:null,
        current:null,
        temperature:null,
        val:[]
},{
  name:['气烧窑3#主引风机_YLT01'],
  nameshow:'气烧窑3#主引风机_YLT01',
        leftX:"20%",
        topY:'37%',
        status:null,
        current:null,
        temperature:null,
        val:[]
}

// {
    
//     nameshow:'聚合釜卸料泵_PVCYZ277',
//     leftX:"70%",
//     topY:'30%',
//     status:null,
//     current:null,
//     temperature:null,
//     val:[]
// },
// {
 
//   nameshow:'聚合釜卸料泵_PVCYZ278',
//   leftX:"72%",
//   topY:'30%',
//   status:null,
//   current:null,
//   temperature:null,
//   val:[]
// },
// {
 
//   nameshow:'聚合釜卸料泵_PVCYZ279',
//   leftX:"74%",
//   topY:'30%',
//   status:null,
//   current:null,
//   temperature:null,
//   val:[]
// },
// {
  
//     nameshow:'VCM加料泵_PVCYZ306',
//     leftX:"75%",
//     topY:'25%',
//     status:null,
//     current:null,
//     temperature:null,
//     val:[]
// },
// {

//   nameshow:'VCM加料泵_PVCYZ307',
//   leftX:"77%",
//   topY:'25%',
//   status:null,
//   current:null,
//   temperature:null,
//   val:[]
// },
// {
      
//       nameshow:'1#炉净气风机_DSYZ001',
//       leftX:"13%",
//       topY:'45%',
//       status:null,
//       current:null,
//       temperature:null,
//       val:[]
// },
// {
    
//       nameshow:'8#炉净气风机_DSYZ206',
//       leftX:"43%",
//       topY:'46%',
//       status:null,
//       current:null,
//       temperature:null,
//       val:[]
// },
// {

//   nameshow:'给水泵2_HCYZ002',
//         leftX:"58%",
//         topY:'38%',
//         status:null,
//         current:null,
//         temperature:null,
//         val:[]
// },
// {
  
//   nameshow:'给水泵1_HCYZ001',
//         leftX:"60%",
//         topY:'38%',
//         status:null,
//         current:null,
//         temperature:null,
//         val:[]
// },
// {
//   nameshow:'球罐单体泵A_HCYZ080',
//   leftX:"70%",
//   topY:'40%',
//   status:null,
//   current:null,
//   temperature:null,
//   val:[]
// },
// {
//   nameshow:'球罐单体泵B_HCYZ081',
//   leftX:"72%",
//   topY:'40%',
//   status:null,
//   current:null,
//   temperature:null,
//   val:[]
// },
// {
 
//   nameshow:'阳极液循环泵_SJYZ019',
//   leftX:"73%",
//   topY:'48%',
//   status:null,
//   current:null,
//   temperature:null,
//   val:[]
// },
// {
//   nameshow:'阳极液循环泵_SJYZ020',
//   leftX:"75%",
//   topY:'48%',
//   status:null,
//   current:null,
//   temperature:null,
//   val:[]
// },
// {
 
//   nameshow:'氢压机_SJYZ055',
//   leftX:"68%",
//   topY:'47%',
//   status:null,
//   current:null,
//   temperature:null,
//   val:[]
// },
// {
  
//   nameshow:'氢压机_SJYZ085',
//   leftX:"47%",
//   topY:'46%',
//   status:null,
//   current:null,
//   temperature:null,
//   val:[]
// },
// {
 
//   nameshow:'烧碱泵_SJYZ122',
//   leftX:"51%",
//   topY:'44%',
//   status:null,
//   current:null,
//   temperature:null,
//   val:[]
// },
// {

//   nameshow:'烧碱泵_SJYZ123',
//   leftX:"53%",
//   topY:'44%',
//   status:null,
//   current:null,
//   temperature:null,
//   val:[]
// },
// {
 
//   nameshow:'氢压机_GJYZ200',
//   leftX:"51%",
//   topY:'28%',
//   status:null,
//   current:null,
//   temperature:null,
//   val:[]
// },
// {
 
//   nameshow:'氢压机_GJYZ201',
//   leftX:"53%",
//   topY:'28%',
//   status:null,
//   current:null,
//   temperature:null,
//   val:[]
// },
// {
//   nameshow:'氢压机_GJYZ202',
//   leftX:"55%",
//   topY:'28%',
//   status:null,
//   current:null,
//   temperature:null,
//   val:[]
// },
// {
 
//   nameshow:'压缩机_YQYZ001',
//         leftX:"30%",
//         topY:'32%',
//         status:null,
//         current:null,
//         temperature:null,
//         val:[]
// },
// {
  
//   nameshow:'压缩机_YQYZ002',
//         leftX:"32%",
//         topY:'32%',
//         status:null,
//         current:null,
//         temperature:null,
//         val:[]
// },
// {
  
//   nameshow:'压缩机_YQYZ003',
//         leftX:"33%",
//         topY:'32%',
//         status:null,
//         current:null,
//         temperature:null,
//         val:[]
// },
// {

//   nameshow:'压缩机_YQYZ004',
//         leftX:"34%",
//         topY:'32%',
//         status:null,
//         current:null,
//         temperature:null,
//         val:[]
// },
// {

//   nameshow:'压缩机_YQYZ005',
//         leftX:"35%",
//         topY:'32%',
//         status:null,
//         current:null,
//         temperature:null,
//         val:[]
// },
// {
  
//   nameshow:'气烧窑3#主引风机_YLT01',
//         leftX:"20%",
//         topY:'37%',
//         status:null,
//         current:null,
//         temperature:null,
//         val:[]
// }
]
// {
//     '聚合釜卸料泵_PVCYZ277':{
//       name:['聚合釜卸料泵_PVCYZ277','聚合釜卸料泵_PVCYZ278','聚合釜卸料泵_PVCYZ279'],
//       leftX:"70%",
//       topY:'30%',
//       status:null,
//       current:null,
//       temperature:null,
//       val:[]
//     },
//     'VCM加料泵_PVCYZ306':{
//       name:['VCM加料泵_PVCYZ306','VCM加料泵_PVCYZ307'],
//       leftX:"75%",
//       topY:'25%',
//       status:null,
//       current:null,
//       temperature:null,
//       val:[]
//     },

//     '1#炉净气风机_DSYZ001':{
//       name:'1#炉净气风机_DSYZ001',
//       leftX:"13%",
//       topY:'45%',
//       status:null,
//       current:null,
//       temperature:null,
//       val:[]
//     },
//     '8#炉净气风机_DSYZ206':{
//       name:'8#炉净气风机_DSYZ206',
//       leftX:"43%",
//       topY:'46%',
//       status:null,
//       current:null,
//       temperature:null,
//       val:[]
//     },
//     '给水泵2_HCYZ002':{
//       name:['给水泵2_HCYZ002','给水泵1_HCYZ001'],
//       leftX:"58%",
//       topY:'38%',
//       status:null,
//       current:null,
//       temperature:null,
//       val:[]
//     },
//     '球罐单体泵A_HCYZ080':{
//       name:['球罐单体泵A_HCYZ080','球罐单体泵B_HCYZ081'],
//       leftX:"70%",
//       topY:'40%',
//       status:null,
//       current:null,
//       temperature:null,
//       val:[]
//     },
//     '阳极液循环泵_SJYZ019':{
//       name:['阳极液循环泵_SJYZ019','阳极液循环泵_SJYZ020'],
//       leftX:"71%",
//       topY:'44%',
//       status:null,
//       current:null,
//       temperature:null,
//       val:[]
//     },
   
//     '氢压机_SJYZ055':{
//       name:'氢压机_SJYZ055',
//       leftX:"68%",
//       topY:'47%',
//       status:null,
//       current:null,
//       temperature:null,
//       val:[]
//     },
//     '氢压机_SJYZ085':{
//       name:'氢压机_SJYZ085',
//       leftX:"47%",
//       topY:'46%',
//       status:null,
//       current:null,
//       temperature:null,
//       val:[]
//     },
//     '烧碱泵_SJYZ122':{
//       name:['烧碱泵_SJYZ122','烧碱泵_SJYZ123'],
//       leftX:"51%",
//       topY:'44%',
//       status:null,
//       current:null,
//       temperature:null,
//       val:[]
//     },
  
//     '氢压机_GJYZ200':{
//       name:['氢压机_GJYZ200','氢压机_GJYZ201','氢压机_GJYZ202'],
//       leftX:"51%",
//       topY:'28%',
//       status:null,
//       current:null,
//       temperature:null,
//       val:[]
//     },
   
//     '压缩机_YQYZ001':{
//       name:['压缩机_YQYZ001','压缩机_YQYZ002','压缩机_YQYZ003','压缩机_YQYZ004','压缩机_YQYZ005'],
//       leftX:"30%",
//       topY:'32%',
//       status:null,
//       current:null,
//       temperature:null,
//       val:[]
//     },

//     '气烧窑3#主引风机_YLT01':{
//       name:'气烧窑3#主引风机_YLT01',
//       leftX:"20%",
//       topY:'37%',
//       status:null,
//       current:null,
//       temperature:null,
//       val:[]
//     },  
    
//     }